import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import App from './App';
import { AccessibilityPreferencesProvider } from './accessibility/AccessibilityPreferences';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AccessibilityPreferencesProvider>
      <App />
    </AccessibilityPreferencesProvider>
  </StrictMode>,
);
